export const MAX_TESTIMONIALS = 12;
export const DEFAULT_TILES_PER_PAGE = 3;
export const DEFAULT_MAX_HEIGHT = 450;
